import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { dateformat, textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import {
  allBlopedFechasAction,
  deleteBlopedFechasAction,
  setActivoBlopedFechasAction,
} from '../BlopedFechasAction';
import { PARAMS_BLOPED_FECHAS } from '../BlopedFechasReducer';

const ListadoBlopedFechas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const blopedFechasStore = Redux.useSelector((state) => state.blopedFechas);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);
  const [fechaActiva, setFechaActiva] = React.useState(false);
  const [rows, setRows] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const payload = {
        ...blopedFechasStore.params,
        idBloquePedagogico: bloquesPedagogicosStore.activo.id,
      };
      dispatch({ type: PARAMS_BLOPED_FECHAS, payload });
      await allBlopedFechasAction(dispatch, payload);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bloquesPedagogicosStore.activo]);

  React.useEffect(() => {
    let dataRows = [];
    blopedFechasStore.all.forEach((el) => {
      dataRows.push({
        ...el,
        periodoAcademico: `${el.periodoAcademico.desde}-${el.periodoAcademico.hasta} (${el.periodoAcademico.nombre})`,
        estatus: el.estatus.nombre,
      });
    });
    setRows(dataRows);
  }, [blopedFechasStore.all]);

  const _handleEditClick = async (id) => {
    const data = blopedFechasStore.all.find((el) => el.id === id);
    await setActivoBlopedFechasAction(dispatch, data);
    setOpenModalForm(true);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deleteBlopedFechasAction(
      { dispatch, notify },
      blopedFechasStore.activo.id,
      blopedFechasStore.params,
    );
    setOpenModalDelete(false);
    setLoadingDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.periodoAcademico.name,
      label: CONST.periodoAcademico.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row" alignItems="center" spacing={1}>
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
                mr="0"
              >
                {value ?? 'N/A'}
              </NameComponent>
              {tableMeta.rowData[0] ===
                bloquesPedagogicosStore.activo.fechaActiva?.id && (
                <Chip label="ASIGNADO" size="small" color="info" />
              )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.activo.name,
      label: CONST.activo.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Chip
              label={value ? 'SI' : 'NO'}
              size="small"
              color={value ? 'success' : 'error'}
            />
          );
        },
      },
    },
    {
      name: CONST.desde.name,
      label: CONST.desde.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return dateformat(value, { inverse: true });
        },
      },
    },
    {
      name: CONST.hasta.name,
      label: CONST.hasta.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return dateformat(value, { inverse: true });
        },
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value}
                size="small"
                color={value === 'ACTIVO' ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = blopedFechasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  setFechaActiva(data.activo);
                  await setActivoBlopedFechasAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
                onDownload={() => {
                  const data = blopedFechasStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  window.open(data.url);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];
  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    download: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget
          isLoading={blopedFechasStore.loadingAll || loadingDelete}
        />
        <MUIDataTable
          title={'Listado'}
          data={rows}
          columns={columns}
          options={options}
        />
      </Grid>
      {blopedFechasStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
          isText={!fechaActiva}
          isConfirmBottom={!fechaActiva}
        >
          {fechaActiva ? (
            <Typography variant="h6">
              No puedes eliminar esta fecha, porque se encuentra activa en el
              bloque pedagógico
            </Typography>
          ) : (
            <Typography variant="h6">
              {blopedFechasStore.activo.nombre}
            </Typography>
          )}
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoBlopedFechas;
